module.exports = __webpack_public_path__ + "app/components/layout/header.view.html";